import { render, staticRenderFns } from "./userCouponManage.vue?vue&type=template&id=090e12e6&scoped=true"
import script from "./userCouponManage.vue?vue&type=script&lang=js"
export * from "./userCouponManage.vue?vue&type=script&lang=js"
import style0 from "./userCouponManage.vue?vue&type=style&index=0&id=090e12e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090e12e6",
  null
  
)

export default component.exports